import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { CommonLayout } from "../components/CommonLayout";
import { Recipients } from "components/Recipients";
import { RecipientDetails } from "components/RecipientDetails";
import { Users } from "components/Users";
import { HardButtonActivations } from "components/HardButtonActivations";
import { Referrals } from "components/Referrals";
import { ReferralDetails } from "components/ReferralDetails";
import { Practices } from "components/Practices";
import { Profile } from "components/Profile";
import { AllButtons } from "components/AllButtons";
import { ReactComponent as RecipientIcon } from "images/recipient-icon.svg";
import { ReactComponent as ReferralsIcon } from "images/referrals-icon.svg";
import { ReactComponent as PracticesIcon } from "images/practices-icon.svg";
import { ReactComponent as OriginatorsIcon } from "images/originators-icon.svg";
import { ReactComponent as ButtonsIcon } from "images/buttons-icon.svg";
import { ReactComponent as SpecialistsIcon } from "images/specialists-icon.svg";
import { ReactComponent as BillingIcon } from "images/billing-icons.svg";
import { ReactComponent as AccessLogIcon } from "images/access_logs.svg";
import { Billing } from "components/Billing";
import { InvoiceDetails } from "components/InvoiceDetails";
import { Regions } from "components/Regions";
import { AccessLogs } from "components/AccessLogs";
import { MyButtons } from "components/MyButtons";
import { Analytics } from "components/Analytics";
import { PracticeDetails } from "components/PracticeDetails";
import { Senders } from "components/Senders";
import { Payments } from "components/Payments";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <CommonLayout
        menu={[
          { label: "Recipients", path: "/", Icon: RecipientIcon },
          {
            label: "Referrals",
            path: "/referral_stream_data",
            Icon: ReferralsIcon,
          },
          { label: "Practices", path: "/practices", Icon: PracticesIcon },
          {
            label: "Senders",
            path: "/senders",
            Icon: OriginatorsIcon,
          },
          {
            label: "Buttons",
            path: "/button_locations",
            Icon: ButtonsIcon,
          },
          {
            label: "Activations",
            path: "/1_click_buttons",
            Icon: ButtonsIcon,
          },
          { label: "Regions", path: "/regions", Icon: PracticesIcon },
          {
            label: "Users",
            path: "/users",
            Icon: SpecialistsIcon,
          },
          {
            label: "Billing",
            path: "/billing",
            Icon: BillingIcon,
          },
          {
            label: "Payments",
            path: "/payments",
            Icon: BillingIcon,
          },
          {
            label: "Analytics",
            path: "/analytics",
            Icon: ReferralsIcon,
          },
          {
            label: "Access Logs",
            path: "/access_logs",
            Icon: AccessLogIcon,
          },
        ]}
      />
    ),
    children: [
      {
        path: "/",
        element: <Recipients />,
      },
      {
        path: "/analytics",
        element: <Analytics />,
      },
      {
        path: "/practices",
        element: <Practices />,
      },
      {
        path: "/senders",
        element: <Senders />,
      },
      {
        path: "/recipient/:id",
        element: <RecipientDetails />,
      },
      {
        path: "/practice/:id",
        element: <PracticeDetails />,
      },
      {
        path: "/users",
        element: <Users />,
      },
      {
        path: "/1_click_buttons",
        element: <HardButtonActivations />,
      },
      {
        path: "/button_locations",
        element: <AllButtons />,
      },
      {
        path: "/my_button_dashboard",
        element: <MyButtons />,
      },
      {
        path: "/regions",
        element: <Regions />,
      },
      {
        path: "/referral/:id",
        element: <ReferralDetails />,
      },
      {
        path: "/referral_stream_data",
        element: <Referrals />,
      },
      {
        path: "/profile",
        element: <Profile />,
      },
      {
        path: "/access_logs",
        element: <AccessLogs />,
      },
      {
        path: "/billing",
        element: <Billing />,
      },
      {
        path: "/payments",
        element: <Payments />,
      },
      {
        path: "/invoice/:id",
        element: <InvoiceDetails />,
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
      },
    ],
  },
]);

export const SuperAdmin = () => <RouterProvider router={router} />;
